import React, {useEffect, useState} from 'react';
import SettingsSection from '../../components/SettingSection';
import ReactSwitch from 'react-switch';
import {connect} from 'react-redux';
import Button from '../../../../components/form/Button';
import {getHttpClient} from '../../../../api';
import {Link} from 'react-router-dom';
import FormGroup from '../../../../components/form/FormGroup';
import settingsStateToProps from '../../settingsStateToProps';
import settingsDispatchToProps
    from '../../premiumextras/settingsDispatchToProps';
import {SettingsMap} from '../../../../components/VideoAndHelpSectionMap';

function ShopifyAccountSync({updateSettings, account_sync_opt_in_email_marketing, store_account_sync, subscription, account_sync_custom_tags}) {
    const [resyncing, setResyncing] = useState(false)
    const [customTags, setCustomTags] = useState(account_sync_custom_tags)
    const [saving, setSaving] = useState(false)
    function startResync(){
        setResyncing(true);
        getHttpClient().post('/integrations/store_account/do_initial_sync')
            .then(({data})=>{
                setResyncing(false)
            }).catch(()=>{
            setResyncing(false)
        })
    }
    useEffect(()=>{
        setCustomTags(account_sync_custom_tags)
    },[account_sync_custom_tags])
    function submit(e){
        if(e){
                e.preventDefault();
                e.stopPropagation();
            }
        setSaving(true)
            updateSettings({
                account_sync_custom_tags:customTags
            }).then(()=>{
                setSaving(false)
            })
    }
     return (
        <SettingsSection title={"Account Sync"} helpLink={SettingsMap.get('Integrations').AccountSync.helpLink} videoID={SettingsMap.get('Integrations').AccountSync.videoID} subtitle={"Automatically registers affiliates as store customers"}>
            {
                subscription === 1 ? <>
                    <div className="d-flex justify-content-between">
                        <ReactSwitch checked={store_account_sync} onChange={(store_account_sync)=>updateSettings({store_account_sync})}/>
                        {
                            store_account_sync && <>
                                <Button loading={resyncing} onClick={startResync} className={"btn btn-link px-0"}>Re-Sync</Button>
                            </>
                        }
                    </div>
                    {
                        store_account_sync ? <form onSubmit={submit}>
                            <FormGroup label={"Tag synced accounts with tag"} info={"You can separate tags with a comma"}>
                                <div className="row">
                                    <div className="col-8">
                                        <input type="text" disabled={saving} className="form-control" value={customTags} onChange={(e)=>setCustomTags(e.target.value)} placeholder={"affiliate,goaffpro"} />
                                    </div>
                                    <div className="col-4">
                                        {
                                            saving || customTags!==account_sync_custom_tags ? <Button loading={saving} className={"btn btn-primary"} onClick={submit} title={"Submit"}/> : null
                                        }
                                    </div>
                                </div>
                            </FormGroup>
                            <FormGroup label={"Auto opt in to email marketing"}>
                                <div>
                                    <ReactSwitch checked={account_sync_opt_in_email_marketing} onChange={(account_sync_opt_in_email_marketing)=>updateSettings({account_sync_opt_in_email_marketing})} />
                                </div>
                            </FormGroup>
                        </form> : null
                    }
                    </>
                    : <Link to={"/subscriptions"}>Upgrade to activate</Link>
            }

        </SettingsSection>
    );
}
export default connect(settingsStateToProps([
    'account_sync_opt_in_email_marketing',
    'store_account_sync','subscription','account_sync_custom_tags']), settingsDispatchToProps)(ShopifyAccountSync);
